function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197,176.66c0,27.34-22.08,49.58-49.2,49.58A49.06,49.06,0,1,1,197,176.66Zm-7.52,0a41.78,41.78,0,1,0-41.68,42.06A41.73,41.73,0,0,0,189.49,176.66Z",
    style: {
      fill: "#9da0a5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.41,210.79a34.62,34.62,0,0,1-13.8-3.16c-13.84-6-16.62-16.08-16.73-16.51a3.76,3.76,0,0,1,7.26-1.94c.1.37,2.24,7.11,12.47,11.56,10.79,4.7,16.51,1.49,16.75,1.35a3.76,3.76,0,1,1,4,6.38,17,17,0,0,1-6.75,2.13A25.81,25.81,0,0,1,155.41,210.79Z",
    style: {
      fill: "#f05151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,307.38c15.64-39,56.53-66.24,104-66.24h1.94c47.45,0,88.17,27.05,104,66.24a3.76,3.76,0,0,1-3.48,5.16H46a3.75,3.75,0,0,1-3.49-5.16ZM51.74,305H243.16c-16-33.34-52.26-56.37-94.74-56.37h-1.94C104,248.65,67.58,271.81,51.74,305Z",
    style: {
      fill: "#9da0a5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,56.73a8.74,8.74,0,0,0-6,2.37,7.62,7.62,0,0,0-2.41,5.52v64a7.6,7.6,0,0,0,2.41,5.52,8.74,8.74,0,0,0,6,2.37h18.3a3.76,3.76,0,0,1,3.76,3.76v22L274.9,137.2a3.79,3.79,0,0,1,2.12-.65h48.79a8.72,8.72,0,0,0,6-2.37,7.61,7.61,0,0,0,2.42-5.52v-64a7.63,7.63,0,0,0-2.42-5.52,8.72,8.72,0,0,0-6-2.37Zm0-7.52H325.81A16.28,16.28,0,0,1,337,53.66a15.12,15.12,0,0,1,4.74,11v64a15.12,15.12,0,0,1-4.74,11,16.28,16.28,0,0,1-11.22,4.45H278.18l-41.74,28.46a3.77,3.77,0,0,1-5.88-3.11V144.07H216a16.28,16.28,0,0,1-11.22-4.45,15.16,15.16,0,0,1-4.74-11v-64a15.16,15.16,0,0,1,4.74-11A16.28,16.28,0,0,1,216,49.21Z",
    style: {
      fill: "#9da0a5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,119.93a3.76,3.76,0,0,1,3.76-3.76h39.65a3.76,3.76,0,0,1,0,7.52H222.12A3.76,3.76,0,0,1,218.36,119.93Z",
    style: {
      fill: "#9da0a5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31,119.93a3.76,3.76,0,0,1,3.76-3.76h39.64a3.76,3.76,0,0,1,0,7.52H280.07A3.76,3.76,0,0,1,276.31,119.93Z",
    style: {
      fill: "#9da0a5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,102.46a3.76,3.76,0,0,1,3.76-3.76h70.14a3.76,3.76,0,0,1,0,7.52H222.12A3.76,3.76,0,0,1,218.36,102.46Z",
    style: {
      fill: "#9da0a5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.81,102.46a3.76,3.76,0,0,1,3.76-3.76h9.15a3.76,3.76,0,0,1,0,7.52h-9.15A3.76,3.76,0,0,1,306.81,102.46Z",
    style: {
      fill: "#9da0a5",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.c3f7f156bc6a72a6b5c23766da6a2186.svg";
export { ForwardRef as ReactComponent };